import React, { useMemo } from 'react';
import { Icon } from '@atlas/ui';

const DatePicker = ({ disabled = false, date, setDate, isOutsideRange }) => {
  const minDate = useMemo(() => isOutsideRange.from.format('YYYY-MM-DD'), [isOutsideRange.from]);
  const maxDate = useMemo(() => isOutsideRange.to.format('YYYY-MM-DD'), [isOutsideRange.to]);

  return (
    <div className="date-picker">
      <input
        type="date"
        value={date}
        className="date-picker__input"
        disabled={disabled}
        onChange={e => setDate(e.target.value)}
        min={minDate && minDate}
        max={maxDate && maxDate}
      />

      <Icon name="calendar" />
    </div>
  );
};

export default DatePicker;
